import React from 'react';

export const ConditionalRender = (props: { shouldRender: boolean, children: JSX.Element }): JSX.Element => {
    return props.shouldRender ? props.children : <></>;
};
